import * as XLSX from 'xlsx-js-style';

export const exportToExel = <T = unknown>(
  table: T[],
  fileName: string = 'Таблица'
) => {
  const sheetName = fileName.length > 31 ? fileName.slice(0, 31) : fileName;

  const wb = XLSX.utils.book_new();

  const ws = XLSX.utils.json_to_sheet(table, { skipHeader: true });

  const range = XLSX.utils.decode_range(ws['!ref'] || '');
  for (let R = range.s.r; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];
      debugger;
      if (cell && typeof cell.v === 'number') {
        cell.z = '#,##0.00';
      }
    }
  }

  ws['A1'].s = {
    font: {
      bold: true,
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center',
    },
  };

  ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }];

  ws['!cols'] = [];
  for (const key in table[0]) {
    ws['!cols'].push({ width: 30 });
  }

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, `${sheetName}.xlsx`);
};
